// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "h1[data-v-40c97d96]{font-size:20px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
